import React, { createContext, useEffect, useReducer, useState } from 'react'
import * as Styles from './LiveRoom.style'
import { ILiveRoomItem } from '../../../../services/Modules/SearchServer'
import { withRouter, RouterProps } from 'react-router'
interface IProps extends RouterProps {
    data: ILiveRoomItem[],
    keyword: string
}
const PERSON_ICON = 'https://static-1253442168.image.myqcloud.com/picture/12937775_c37081a65d407576ba5dce8b7da716fa.jpg-picmsg420'
const CORPORATION_ICON = 'https://static-1253442168.image.myqcloud.com/picture/12937775_7df32840e1a3f14d90642e0cd5ce49fa.jpg-picmsg420'

const enum VERY_TYPE {
    PERSON = 1,
    CORPORATION = 2
}
function getAvatarIcon(verifyType: VERY_TYPE) {
    if (verifyType === VERY_TYPE.PERSON) {
        return <img className={Styles.icon} src={PERSON_ICON} alt=""/>
    }

    if (verifyType === VERY_TYPE.CORPORATION) {
        return <img className={Styles.icon} src={CORPORATION_ICON} alt=""/>
    }
    return null
}
function LiveRoom(props: IProps) {
    const { data } = props
    const showList = data.slice(0, 3)

    function goLiveRoom(roomId: number) {
        if (/lycheer/.test(navigator.userAgent.toLocaleLowerCase())) {
            window.location.href = `lizhiweike://liveroom?liveroom_id=${roomId}`
        } else {
            window.location.href = `/liveroom/${roomId}`
        }
    }

    return (
        <div className={Styles.container}>
            <div className={Styles.title}>
                <span className={Styles.bold}>直播间</span>
                <span className={Styles.right} onClick={() => props.history.push(`/more-liveroom?keyword=${props.keyword}`)}>查看更多
                    <span className={Styles.arrow} />
                </span>
            </div>
            <div className={Styles.list}>
                {
                    showList.map(item =>
                        <div key={item.id} className={Styles.listItem} onClick={() => goLiveRoom(item.id)}>
                            <div className={Styles.avatar}>
                                <img className={Styles.pic} src={item.avatar_url} alt=""/>
                                {getAvatarIcon(item.verify_type)}
                            </div>
                            <div className={Styles.name}>
                                {item.name}
                            </div>
                            <div className={Styles.personNumb}>
                                {item.fans_count >= 10000 ? (item.fans_count / 10000).toFixed(2) + '万' : item.fans_count}<span>人关注</span>
                            </div>
                        </div>
                    )
                }

            </div>
        </div>
    )

}

export default withRouter(LiveRoom as any) as any



// WEBPACK FOOTER //
// ./src/views/SearchResult/components/LiveRoom/LiveRoom.tsx